"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabContent = void 0;
var react_1 = __importDefault(require("react"));
var TabContent = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "border" : _b;
    return (react_1.default.createElement("div", { className: className, style: { marginTop: -1 } }, children));
};
exports.TabContent = TabContent;
